<template>
           <div class="loading">
               <img src="../../static/images/jz.gif" style="width:100;height:68px;position:absolute;top:50%;left:50%;z-index:101;" alt="">
             </div>
</template>

<script>
export default {
  name: 'Loading' // 定义的组件名称 使用时写法：loading
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Loading1.vue